import React, { useEffect, useState } from "react";
import { Input } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { Card, CardHeader, CardBody } from "@progress/kendo-react-layout";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import ApiUrls from "../../helper/api-urls";
import ApiHelper from "../../helper/api-helper";
import { useDispatch } from "react-redux";
import { GET_ALL_CLINIC } from "../../actions";
import { NotificationManager } from "src/util/notify";
import ErrorHelper from "../../helper/error-helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../control-components/loader/loader";

export default function ServicesTransfer() {
  const [allClinic, setAllClinic] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [fields, setFields] = useState({
    copyFromClinic: "",
    copyToClinic: ""
  });
  
  const dispatch = useDispatch();

  useEffect(() => {
    getAllClinics();
  }, []);

  const handleClinicValidation = (clinicId, fieldName) => {
    if (!clinicId) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: ErrorHelper.CLINIC_ID,
      }));
      return false;
    }
    return true;
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFields((prevFields) => ({ ...prevFields, [name]: value }));
    
    if (name === "copyFromClinic" && value) {
      getClinicStaff(value.id);
    } else if (name === "copyFromClinic" && !value) {
      setStaffList([]);
    }
  };

  const getAllClinics = async () => {
    setLoading(true);
    try {
      const result = await ApiHelper.getRequest(ApiUrls.ALL_CLINIC);
      dispatch({
        type: GET_ALL_CLINIC,
        payload: result.resultData,
      });
      setAllClinic(result.resultData);
    } catch (error) {
      NotificationManager.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const getClinicStaff = async (masterClinicId) => {
    setLoading(true);
    if (handleClinicValidation(masterClinicId, "copyFromClinic")) {
      const postData = {
        masterClinicId,
        staffId: 0,
        userName: "",
        email: "",
        firstName: "",
        lastName: "",
      };

      try {
        const result = await ApiHelper.postRequest(ApiUrls.GET_STAFF, postData);
        const filteredList = result?.resultData?.map(({ staffId, staffName }) => ({
          staffId,
          staffName,
        }));
        setStaffList(filteredList);
      } catch (error) {
        NotificationManager.error(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleValidation = () => {
    let formIsValid = true;
    const errors = {};
    
    if (!fields.copyFromClinic) {
      formIsValid = false;
      errors.copyFromClinic = ErrorHelper.CLINIC_ID;
    }
    if (!fields.copyToClinic) {
      formIsValid = false;
      errors.copyToClinic = ErrorHelper.CLINIC_ID;
    }

    setErrors(errors);
    return formIsValid;
  };

  const copyServices = async () => {
    setLoading(true);
    const postData = {
      copyFromMasterClinicId: fields.copyFromClinic.id,
      copyToMasterClinicId: fields.copyToClinic.id
    };

    try {
      await ApiHelper.postRequest(ApiUrls.COPY_SERVICES, postData);
      setFields({
        copyFromClinic: "",
        copyToClinic: ""
      });
      NotificationManager.success("Request has been submitted to the queue successfully, please note completion may take several minutes");
    } catch (error) {
      NotificationManager.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      {loading ? (
        <Loader />
      ) : (
        <div className="row justify-content-center">
          <h2 className="text-center mb-4 fw-bold" style={{ marginRight: "10%" }}>
            Services Transfer
          </h2>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="col-md-5">
              <Card className="border-success shadow" style={{ minHeight: "250px" }}>
                <CardHeader className="bg-success text-white text-center">
                  <h4 className="fw-bold">COPY FROM</h4>
                </CardHeader>
                <CardBody className="p-4">
                  <div className=" edit-Service-popup">
                    <DropDownKendoRct
                    validityStyles={false}
                    label="Master Clinic"
                    onChange={handleChange}
                    data={allClinic}
                    value={fields.copyFromClinic}
                    textField="clinicName"
                    name="copyFromClinic"
                    error={errors.copyFromClinic}
                    required
                  />
                  </div>
                  
                </CardBody>
              </Card>
            </div>
            <FontAwesomeIcon icon={faArrowRight} style={{ margin: "0 5px", fontSize: "50px" }} />
            <div className="col-md-5">
              <Card className="border-danger shadow" style={{ minHeight: "250px" }}>
                <CardHeader className="bg-danger text-white text-center">
                  <h4 className="fw-bold">COPY TO</h4>
                </CardHeader>
                <CardBody className="p-4">
                  <div className=" edit-Service-popup">
                     <DropDownKendoRct
                    validityStyles={false}
                    label="Master Clinic"
                    onChange={handleChange}
                    data={allClinic}
                    value={fields.copyToClinic}
                    textField="clinicName"
                    name="copyToClinic"
                    error={errors.copyToClinic}
                    required
                  />
                  </div>
                 
                </CardBody>
              </Card>
            </div>
          </div>
          <div className="text-center mt-4" style={{ marginRight: "10%" }}>
            <Button
              themeColor="primary"
              size="large"
              className="px-5 green-btn btn-primary mr-2"
              onClick={() => handleValidation() && copyServices()}
            >
              Copy Services
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
